// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
// import { CustomEase } from "gsap/CustomEase.js"; // カスタムイージング作成が必要なときは使用

gsap.registerPlugin(ScrollTrigger);

// Fixed[初期値] => Absolute
// 固定するセクションに　.js-switch-absolute
// .js-switch-absoluteのラッパー（.js-switch-absoluteのみを内包）に.js-switch-absolute-wrapper
function switchAbsolute(onInit) {
  if (document.querySelector('.js-switch-absolute-wrapper .js-switch-absolute')) {

    onInit();

    document.querySelectorAll('.js-switch-absolute-wrapper .js-switch-absolute').forEach(target => {
      try {
        const wrapper = target.closest('.js-switch-absolute-wrapper');
        if (!wrapper) {
          throw new Error('Fixed => Absolute切替処理の親要素 .js-switch-absolute-wrapper がありません');
        }
        gsap.to(target, {
          scrollTrigger: {
            trigger: wrapper,
            start: `bottom bottom`,
            scrub: true,
            onEnter: function() {
              target.classList.add('--absolute');
            },
            onLeaveBack: function() {
              target.classList.remove('--absolute');
            },
          }
        });
      } catch(err) {
        console.error(err);
      }
    })
  }
}

// [初期値] => Fixed
// 固定するセクションに　.js-switch-fixed
// .js-switch-fixedのラッパー（.js-switch-fixedのみを内包）に.js-switch-fixed-wrapper
function switchFixed(onInit) {
  if (document.querySelector('.js-switch-fixed-wrapper .js-switch-fixed')) {

    onInit();

    document.querySelectorAll('.js-switch-fixed-wrapper .js-switch-fixed').forEach(target => {
      try {
        const wrapper = target.closest('.js-switch-fixed-wrapper');
        if (!wrapper) {
          throw new Error('Fixedへ切替処理の親要素 .js-switch-fixed-wrapper がありません');
        }

        wrapper.style.height = `${Math.floor(target.clientHeight)}px`;

        gsap.to(target, {
          scrollTrigger: {
            trigger: wrapper,
            start: `bottom bottom`,
            scrub: true,
            onEnter: function() {
              target.classList.add('--fixed');
            },
            onLeaveBack: function() {
              target.classList.remove('--fixed');
            },
          }
        });
      } catch(err) {
        console.error(err);
      }
    })
  }
}
function setSpacerHeight() {
  if (document.querySelector('.js-switch-fixed .p-front-spacer')) {
    set();

    window.addEventListener('resize', set);

    function set() {
      const spacer = document.querySelector('.p-front-spacer');
      const wrap = spacer.closest('.js-switch-fixed');
      const spacerHeight = Math.floor(spacer.clientHeight);
      if (wrap.clientHeight < window.innerHeight) {
        spacer.style.height = `${spacerHeight + Math.floor(window.innerHeight - wrap.clientHeight)}px`;
      }
    }
  }
}


document.addEventListener('DOMContentLoaded', function() {

  // switchAbsolute()

  switchFixed(setSpacerHeight);
})

